module.exports = __webpack_public_path__ + "img/ArmadilloChecklist_1.ded6d051.gif";